export const HEADER_FADE_SPEED = 200;
export const HEADER_MINI_CLOSE_ALL = 'HEADER_MINI_CLOSE_ALL';
